import axios from 'axios'
import { domains } from './config'

const baseApiAddress = `${domains.SS_API_V4}`
let authInstance

// Shared auth instance used by all clients created via createClient
let sharedAuthInstance

export const createClient = customAddress => {
  const _api = axios.create({
    baseURL: customAddress || baseApiAddress,
    headers: {
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
    },
  })

  _api.interceptors.request.use(async request => {
    if (sharedAuthInstance && sharedAuthInstance.getAccessTokenSilently) {
      const token = await sharedAuthInstance.getAccessTokenSilently()
      request.headers.Authorization = `Bearer ${token}`
    }
    return request
  })

  _api.interceptors.response.use(
    response => {
      return response
    },

    error => {
      if (error && error.response && error.response.status === 401) {
        location.replace(window.location.origin)
      }
      return Promise.reject(error)
    },
  )

  return {
    setAuthInstance: async newAuthInstance => {
      sharedAuthInstance = newAuthInstance
    },
    setBaseUrl: newBaseUrl => {
      _api.defaults.baseURL = newBaseUrl
    },
    delete: _api.delete,
    get: _api.get,
    patch: _api.patch,
    post: _api.post,
    put: _api.put,
  }
}

export default createClient()
